export default __webpack_public_path__ + "static/media/banner.d87b87b6.png";